export const residentialStatuses = {
  local: 'local',
  non_local: 'non_local',
  international: 'international',
  unknown: 'unknown'
}

export const residentialStatusesLabels = {
  [residentialStatuses.local]: 'Locals',
  [residentialStatuses.non_local]: 'Nationals',
  [residentialStatuses.international]: 'Internationals',
  [residentialStatuses.unknown]: 'Unknown'
}
